import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import Premium from "@/pages/Premium";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/premium")({
  head: () => ({
    meta: [
      { title: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { name: "keywords", content: seoFor({ topics: ["home", "nigeria"] }).meta },
      { name: "description", content: "Statlign Premium is $13.50/month: live odds movement alerts, the complete expected-value breakdown behind every call, followed-match email alerts and an ad-free experience." },
      { property: "og:title", content: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Statlign Premium is $13.50/month: live odds movement alerts, the complete expected-value breakdown behind every call, followed-match email alerts and an ad-free experience." },
      { name: "twitter:title", content: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { name: "twitter:description", content: "Statlign Premium is $13.50/month: live odds movement alerts, the complete expected-value breakdown behind every call, followed-match email alerts and an ad-free experience." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Premium />
    </MainLayout>
  ),
});
